<button class='btn btn-info btn-block' type='button' (click)='postcodeLookup()'>Look Up Postcode</button>

@if (this.completeAddresses.length > 0) {
  <app-container>
    <select class='form-control' (change)='this.changedAddress($event)'>
      <option value='-1'>Select an Address</option>
      @for (item of this.completeAddresses; track item) {
        <option [value]='item.id'>{{item.sanitisedAddress}}</option>
      }
      <!-- <option *ngFor='let item of this.addressList' [value]='item.id' [selected]='this.fuel.vehicleId === item.id'>{{ item.name }}</option> -->
    </select>
  </app-container>
}
